import { Button } from "@choose/ui/button";
import { Separator } from "@choose/ui/separator";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ViewList } from "~/components/common/views/view-list";
import { APP_SIDEBAR_NAME } from "~/components/layout/sidebars/app-sidebar";
import { SidebarTrigger } from "~/components/ui/sidebar";
import { useCurrentUserQuery } from "~/graphql/graphql.gen";
import { AGENT_ROLES } from "~/stores/roles-store";
import {
  DEFAULT_DISPLAYED_PROPERTIES,
  DEFAULT_GROUP_BY,
  DEFAULT_SORT,
} from "~/validators/search-tickets-validator";

export const Route = createFileRoute(
  "/_auth/_app_shell/_main-navigation/views/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { data: user } = useCurrentUserQuery(undefined, {
    select: (data) => data.currentUser,
  });

  const hasRights =
    user?.__typename === "ActorInternalUser" &&
    AGENT_ROLES.includes(user.internalUser.supportRole);

  return (
    <>
      <title>{`${t("app_sidebar.views")} - ${t("app_name")}`}</title>
      <div className="bg-background flex w-full flex-col md:rounded-md md:border">
        <div className="flex h-full grow flex-col">
          <header className="flex flex-col items-center">
            <div className="flex h-10 w-full items-center gap-2 border-b px-4">
              <SidebarTrigger name={APP_SIDEBAR_NAME} className="-ml-1" />
              <Separator orientation="vertical" className="mr-2" />

              <h2 className="flex-1 text-sm">{t("app_sidebar.views")}</h2>
              <Button
                type="button"
                variant="secondary"
                size="sm"
                nativeButton={false}
                render={
                  <Link
                    to="/views/add"
                    search={{
                      sort: DEFAULT_SORT,
                      groupBy: DEFAULT_GROUP_BY,
                      displayedProperties: DEFAULT_DISPLAYED_PROPERTIES,
                    }}
                    disabled={!hasRights}
                    className="aria-disabled:pointer-events-none aria-disabled:opacity-50"
                  >
                    {t("views.create_view")}
                  </Link>
                }
              />
            </div>
          </header>
          <div className="h-full w-full overflow-auto">
            <ViewList />
          </div>
        </div>
      </div>
    </>
  );
}
